import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC } from 'react'

import { FormHistoryItem } from '@user/store/agreements/typings'
import { getStatusFromStatusCode } from '@user/store/agreements/utils/getStatusFromStatusCode'

import { splitCamelCase, timeFormat } from '@sales-center/common'

import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Typography from '@mui/material/Typography'
import { useLocalizationDateFormat } from '@user/features/Localization/useLocalizationDateFormat'

const styles = {
  cell: {
    borderBottom: 'none',
  },

  headerCell: {
    borderBottom: 'none',
    fontFamily: 'Source Sans Pro Semibold',
  },

  leftCell: {
    paddingLeft: (theme: Theme) => theme.spacing(0),
  },
}

interface Props {
  history: FormHistoryItem[]
}

export const AgreementHistory: FC<Props> = (props: Props) => {
  const historyTimeline = props.history.sort((a, b) =>
    a.status > b.status ? -1 : 1,
  )
  const { formatDate } = useLocalizationDateFormat()

  return (
    <>
      {!historyTimeline.length ? (
        <Typography>
          There is currently no communication history to display.
        </Typography>
      ) : (
        <Table size="small" style={{ width: 'auto' }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ ...styles.headerCell, ...styles.leftCell }}>
                Date Modified
              </TableCell>
              <TableCell sx={styles.headerCell}>Modified By</TableCell>
              <TableCell sx={styles.headerCell}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {historyTimeline.map((item, index) => (
              <TableRow key={index}>
                <TableCell sx={{ ...styles.cell, ...styles.leftCell }}>
                  {!!item.modifiedDate
                    ? formatDate(item.modifiedDate) +
                      ' at ' +
                      timeFormat(item.modifiedDate)
                    : ''}
                </TableCell>
                <TableCell sx={styles.cell}>{item.modifiedBy}</TableCell>
                <TableCell sx={styles.cell}>
                  <i>{splitCamelCase(getStatusFromStatusCode(item.status))}</i>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  )
}
